'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _includes2 = require('lodash/includes');

var _includes3 = _interopRequireDefault(_includes2);

var _isNil2 = require('lodash/isNil');

var _isNil3 = _interopRequireDefault(_isNil2);

var _isUndefined2 = require('lodash/isUndefined');

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _isPlainObject2 = require('lodash/isPlainObject');

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _isFunction2 = require('lodash/isFunction');

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _toString2 = require('lodash/toString');

var _toString3 = _interopRequireDefault(_toString2);

var _identity2 = require('lodash/identity');

var _identity3 = _interopRequireDefault(_identity2);

exports.default = handleAction;

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function handleAction(type) {
  var reducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity3.default;
  var defaultState = arguments[2];

  !type ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'type should be a string or an async type object') : (0, _invariant2.default)(false) : void 0;
  var types = (0, _toString3.default)(type).split(_config2.default.separator);
  !((0, _isFunction3.default)(reducer) || (0, _isPlainObject3.default)(reducer)) ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'reducer should be a function or an object with next and throw reducers') : (0, _invariant2.default)(false) : void 0;

  !!(0, _isUndefined3.default)(defaultState) ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'defaultState for reducer handling ' + types.join(', ') + ' should be defined') : (0, _invariant2.default)(false) : void 0;

  var _ref = (0, _isFunction3.default)(reducer) ? [reducer] : [reducer.next, reducer.throw].map(function (reducer) {
    return (0, _isNil3.default)(reducer) ? undefined : reducer;
  }),
      _ref2 = (0, _slicedToArray3.default)(_ref, 2),
      nextReducer = _ref2[0],
      throwReducer = _ref2[1];

  return function actionHandler() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];
    var actionType = action.type;

    if (!actionType || !(0, _includes3.default)(types, actionType.toString())) {
      return state;
    }

    var handler = throwReducer && action.error ? throwReducer : nextReducer;
    return handler(state, action);
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/berkeleys-redux-utils/lib/handle-action.js
// module id = 343
// module chunks = 168707334958949